import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = {
  class: "d-flex align-items-center",
  style: {"width":"200px"}
}
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_17 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ModalImage = _resolveComponent("ModalImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des anciens bons")
    ], -1)),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.point_ventes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filtrer par Point de vente ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.point_vente,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.point_vente) = $event)),
                      options: _ctx.point_ventes,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un point de vente"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Image "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date Opér. "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Ref. Doc. "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bonlivraisons, (bonlivraisons, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  bonlivraisons
                    ? (_openBlock(), _createBlock(_component_ModalImage, {
                        key: 0,
                        libelle: bonlivraisons.refDoc,
                        keyValue: bonlivraisons.id,
                        fileUrl: bonlivraisons.imageBon
                      }, null, 8, ["libelle", "keyValue", "fileUrl"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.format_date(bonlivraisons?.dateOperation)), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(bonlivraisons.refDoc), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(bonlivraisons?.client.nomClient) + " " + _toDisplayString(bonlivraisons?.client.prenomClient) + _toDisplayString(bonlivraisons?.client.raisonSociale), 1),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[3] || (_cache[3] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_15, [
                      (_ctx.checkPermission('ViewBonLivraison'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ViewBonAncien', params: { id: bonlivraisons.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode("Détails ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}